import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import {BrowserView, MobileView} from 'react-device-detect';
import 'bootstrap/dist/css/bootstrap.min.css';
import arrow from '../../Assets/arrow 2.png';
import './gallery.css';
import InstagramFeed from '../../components/instagramFeed/instagramfeed';
const projects = [
  {
    id: 1,
    name: "galleryimg1",
    src: require('../../Assets/GalleryImage/126.png')
  },
  {
    id: 2,
    name: "galleryimg2",
    src: require('../../Assets/GalleryImage/127.png')
  },
  {
    id: 3,
    name: "galleryimg3",
    src: require('../../Assets/GalleryImage/128.png')
  },
  {
    id: 4,
    name: "galleryimg4",
    src: require('../../Assets/GalleryImage/129.png')
  },
  {
    id: 5,
    name: "galleryimg5",
    src: require('../../Assets/GalleryImage/130.png')
  },
  {
    id: 6,
    name: "galleryimg6",
    src: require('../../Assets/GalleryImage/131.png')
  },
  {
    id: 7,
    name: "galleryimg7",
    src: require('../../Assets/GalleryImage/132.png')
  },
  {
    id: 8,
    name: "galleryimg8",
    src: require('../../Assets/GalleryImage/133.png')
  },
  {
    id: 9,
    name: "galleryimg9",
    src: require('../../Assets/GalleryImage/134.png')
  },
  {
    id: 10,
    name: "galleryimg10",
    src: require('../../Assets/GalleryImage/135.png')
  },
  {
    id: 11,
    name: "galleryimg11",
    src: require('../../Assets/GalleryImage/136.png')
  },
  {
    id: 12,
    name: "galleryimg12",
    src: require('../../Assets/GalleryImage/137.png')
  },
  {
    id: 13,
    name: "galleryimg13",
    src: require('../../Assets/GalleryImage/138.png')
  },
  {
    id: 14,
    name: "galleryimg14",
    src: require('../../Assets/GalleryImage/139.png')
  },
  {
    id: 15,
    name: "galleryimg15",
    src: require('../../Assets/GalleryImage/140.png')
  }
];

const reviewImages = [
  require('../../Assets/review1.png'),
  require('../../Assets/review2.png'),
  require('../../Assets/review3.png'),
  require('../../Assets/review1.png'),
  require('../../Assets/review2.png')
];

const Gallery = () => {
  // State to track the current index for the review images
  const [currentIndex, setCurrentIndex] = useState(0);

  // Function to show the next set of images
  const showNextImage = () => {
    const newIndex = (currentIndex + 1) % reviewImages.length;
    setCurrentIndex(newIndex);
  };

  // Function to show the previous set of images
  const showPreviousImage = () => {
    const newIndex = (currentIndex - 1 + reviewImages.length) % reviewImages.length;
    setCurrentIndex(newIndex);
  };

  // Calculate the three images to display
  const visibleImages = [
    reviewImages[currentIndex],
    reviewImages[(currentIndex + 1) % reviewImages.length],
    reviewImages[(currentIndex + 2) % reviewImages.length]
  ];

  return (

    <div id="gallery" className='p-0 m-0 gallerypage'>
      <BrowserView>
      <Row>
        {/* First Column for Single Image */}
        <Col xs={12} md={6} lg={5}>
          <div>
            <img src={require('../../Assets/gallery1.png')} className="galleryimage" alt="Adorn Image" />
          </div>
        </Col>

        {/* Second Column for Continuous Looping Gallery */}
        <Col xs={12} md={6} lg={7}>
          <div className="gallery-header">
            <div className="gallerytext">
              <h1>Gallery</h1>
            </div>
            {/* <div className="view-all">
              <a href="#gallery">View More
                <img src={arrow} alt="Arrow" className="arrow-image" />
              </a>
            </div> */}
          </div>

          <div className="gallery">
            <div className="gallery-container">
              {projects.map((p) => (
                <img key={p.id} src={p.src} className="galleryimg" alt="Adorn Image" />
              ))}
              {/* Duplicate images to create a seamless loop */}
              {projects.map((p) => (
                <img key={`${p.id}-duplicate`} src={p.src} className="galleryimg" alt="Adorn Image" />
              ))}
            </div>
          </div>
        </Col>
      </Row>

      <Row>
        <div className='gallery-section'>
          <h2>Voices of Adornment</h2>
          <h1>What Our Clients Say</h1>
        </div>
        
        <div className="gallery-section2">

          {/* Left Button */}
          <button className="left-button" onClick={showPreviousImage}>
            &#8249;
          </button>

          {/* Three Image Display */}
          <div className="image-container">
            {visibleImages.map((image, index) => (
              <img
                key={index}
                src={image}
                className={`reviewimg2 ${index === 1 ? 'center-image' : ''}`}
                alt="Adorn Image"
              />
            ))}
          </div>

          {/* Right Button */}
          <button className="right-button" onClick={showNextImage}>
            &#8250;
          </button>
        </div>
      </Row>


      <Row>
        <InstagramFeed/>
      </Row>

      </BrowserView>
      <MobileView>
      <Row>


        {/* Second Column for Continuous Looping Gallery */}
        <Col>
          <div className="gallery-header">
            <div className="gallerytext">
              <h1>Gallery</h1>
            </div>

          </div>
          <div>
            <img src={require('../../Assets/gallery1.png')} className="galleryimage" alt="Adorn Image" />
          </div>

          <div className="gallery">
            <div className="gallery-container">
              {projects.map((p) => (
                <img key={p.id} src={p.src} className="galleryimg" alt="Adorn Image" />
              ))}
              {/* Duplicate images to create a seamless loop */}
              {projects.map((p) => (
                <img key={`${p.id}-duplicate`} src={p.src} className="galleryimg" alt="Adorn Image" />
              ))}
            </div>
          </div>
          {/* <div className="view-all">
              <a href="#gallery">View More
                <img src={arrow} alt="Arrow" className="arrow-image" />
              </a>
            </div> */}
        </Col>
        <Col>
        <div className='gallery-section'>
          <h2>Voices of Adornment</h2>
          <h1>What Our Clients Say</h1>
        </div>
        
        <div className="gallery-section2">

          {/* Left Button */}
          <button className="left-button" onClick={showPreviousImage}>
            &#8249;
          </button>

          {/* Three Image Display */}
          <div className="image-container">
            {visibleImages.map((image, index) => (
              <img
                key={index}
                src={image}
                className={`reviewimg2 ${index === 1 ? 'center-image' : ''}`}
                alt="Adorn Image"
              />
            ))}
          </div>

          {/* Right Button */}
          <button className="right-button" onClick={showNextImage}>
            &#8250;
          </button>
        </div>
      </Col>
      <Col>
      <InstagramFeed/>
      {/* <div className="gallerycenter">
            <div className="gallery-track">
              {postImages.map((p) => (
                <img key={p.id} src={p.src} className="reviewimgig" alt="Adorn Image" />
              ))}

              {postImages.map((p) => (
                <img key={`${p.id}-duplicate`} src={p.src} className="reviewimgig" alt="Adorn Image" />
              ))}
            </div>
          </div>*/}
      </Col> 

      </Row>
      </MobileView>
    </div>

    
  );
};

export default Gallery;
